<template>
  <period-filter
    ref="periodFilter"
    :loadingList="isLoading"
    :dropdownOptions="dropdownOptions"
    :selectedPeriod="selectedPeriod"
    :min-date="minDate"
    @dateFiltersChanged="search"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PeriodFilter from '@/components/project/globals/PeriodFilter.vue'

import { DATE_PICKER_OPTIONS } from '@/enums/date-picker.enum'
import DateManager from '@/utils/date-manager.utils'
import Amplitude from '@/amplitude-events/resume.amplitude'

export default {
  name: 'DateSelect',
  components: {
    PeriodFilter
  },
  props: {
    isLoading: Boolean
  },

  data () {
    return {
      selectedPeriod: DATE_PICKER_OPTIONS.TODAY,
      dropdownOptions: DATE_PICKER_OPTIONS.NON_ALL_TIME
    }
  },

  computed: {
    ...mapGetters(['accountId', 'merchantId']),

    minDate () {
      return DateManager.sixMonthsAgo()
    },

    queryPeriodFilter () {
      return this.$refs?.periodFilter?.prepareQuery()
    }
  },

  mounted () {
    this.refreshRoute(this.queryPeriodFilter)
  },

  methods: {
    ...mapActions(['GET_DATA_HOME']),

    refreshRoute (query) {
      this.$router.replace({ query }).catch(err => err)
    },
    search () {
      const query = this.queryPeriodFilter

      const params = {
        merchant_id: this.merchantId,
        account_id: this.accountId,
        query
      }

      Amplitude.events.filters.periodChanged(query)

      this.GET_DATA_HOME(params)

      this.trackClickGA(
        'Seleção de período',
        query.date_filters ?? query.period_type
      )

      this.refreshRoute(query)
    },

    trackClickGA (eventName, value) {
      if (this.$gtag)
        this.$gtag.event(eventName, {
          event_category: 'Filtro Home Dash',
          event_label: value
        })
    }
  }
}
</script>
